/**
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import {
	ISchemaFlowNode,
	ISchemaFlowNodeTypeDefinitionMap,
	TGetBlueprintSchemaModel,
	TSchemaEventHandler
} from "@adapptio/lib-blueprint";
import { createContext, useContext } from "react";
import { TReferenceItem } from "../../modules/Core/ReferenceGuide/ReferenceGuideTypes";

/**
 * Function to select event node
 *
 * @param eventName Event name
 * @param eventModel Event model to select
 * @param flowNodeModel Flow node to additionally select (optional)
 */
export type TInspectEventMapSelectFn = (
	eventName: string,
	eventModel: TGetBlueprintSchemaModel<TSchemaEventHandler>,
	flowNodeModel?: TGetBlueprintSchemaModel<ISchemaFlowNode<ISchemaFlowNodeTypeDefinitionMap>>
) => void;

/**
 * Editor Inspector Context
 */
export interface IEditorInspectorContext {
	readOnly?: boolean;
	selectedEventName?: string;
	inputDebounceTimeout?: number;
	onEventSelect?: TInspectEventMapSelectFn;
	onEventUnselect?: TInspectEventMapSelectFn;
	referenceItem?: TReferenceItem;
}

export const EditorInspectorContext = createContext<IEditorInspectorContext>(null);

export function useEditorInspectorContext(): IEditorInspectorContext {
	return useContext<IEditorInspectorContext>(EditorInspectorContext);
}
